function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.867,
    height: 38.529,
    viewBox: "0 0 55.867 38.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15035",
    d: "M55.867 114.677a3.3 3.3 0 0 1-3.3 3.3H3.3a3.3 3.3 0 0 1-3.3-3.3V82.753a3.3 3.3 0 0 1 3.3-3.3h49.265a3.3 3.3 0 0 1 3.3 3.3v31.923z",
    transform: "translate(0 -79.451)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15036",
    d: "m39.574 197.185-1.312-6.293a1.565 1.565 0 0 0-1.692-1.16h-6.014l-.054.288c4.684 1.135 7.784 3.875 9.072 7.165z",
    transform: "translate(-27.174 -177.699)",
    style: {
      fill: "#f79f1a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23863"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15037",
    d: "M189.812 190.892h-3.886l-2.426 14.242h3.879z",
    transform: "translate(-163.476 -178.732)",
    style: {
      fill: "#059bbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15038",
    d: "m73.42 205.2 6.112-14.219h-4.113l-3.8 9.714-.406-1.467a15.2 15.2 0 0 0-5.376-5.9l3.474 11.872z",
    transform: "translate(-58.652 -178.811)",
    style: {
      fill: "#059bbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15039",
    d: "M252.439 198.489c.014-1.617-1.024-2.85-3.261-3.869-1.36-.658-2.188-1.1-2.178-1.764 0-.59.7-1.224 2.222-1.224a7.168 7.168 0 0 1 2.905.546l.351.161.527-3.085a10.066 10.066 0 0 0-3.48-.595c-3.836 0-6.536 1.93-6.561 4.7-.024 2.047 1.93 3.188 3.4 3.87 1.511.7 2.018 1.141 2.008 1.764-.01.954-1.2 1.389-2.32 1.389a8.144 8.144 0 0 1-3.656-.747l-.5-.228-.545 3.192a12.248 12.248 0 0 0 4.323.756c4.084 0 6.736-1.906 6.765-4.866z",
    transform: "translate(-215.02 -176.743)",
    style: {
      fill: "#059bbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15040",
    d: "M345.279 203.12h4.972c.117.5.473 2.135.473 2.135h3.6l-3.144-14.233h-3a1.932 1.932 0 0 0-2.033 1.179l-5.766 13.053h4.08s.666-1.749.818-2.134zm2.661-6.9c-.019.039.322-.824.517-1.36l.263 1.228s.741 3.4.9 4.114h-3.222c.318-.816 1.542-3.979 1.542-3.979z",
    transform: "translate(-303.244 -178.852)",
    style: {
      fill: "#059bbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15041",
    d: "M52.565 79.451H3.3a3.3 3.3 0 0 0-3.3 3.3v3.428h55.867v-3.426a3.3 3.3 0 0 0-3.302-3.302z",
    transform: "translate(0 -79.451)",
    style: {
      fill: "#059bbf"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15042",
    d: "M52.565 377.6H3.3a3.3 3.3 0 0 1-3.3-3.3v-3.427h55.867v3.427a3.3 3.3 0 0 1-3.302 3.3z",
    transform: "translate(0 -339.072)",
    style: {
      fill: "#f79f1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15043",
    d: "M2.348 114.677V82.753a3.3 3.3 0 0 1 3.3-3.3H3.3a3.3 3.3 0 0 0-3.3 3.3v31.923a3.3 3.3 0 0 0 3.3 3.3h2.351a3.3 3.3 0 0 1-3.303-3.299z",
    transform: "translate(0 -79.451)",
    style: {
      fill: "#202121",
      opacity: 0.15
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.16b224cf5e3fa05f0bfb7f9905308a0a.svg";
export { ForwardRef as ReactComponent };